module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "money-car.bcd795b2.png" + "?" + Date.now();